import api from './apiService';
import { API_PATHS } from '../constants/portalApiPath';

const clinicalService = {
  // ─── Patient Progress Scoring ──────────────────────────────────────────────

  // Progress scores for all active patients
  getPatientProgress: (data = {}) =>
    api.post(API_PATHS.CLINICAL_PROGRESS, data),

  // Progress score for a single patient
  getSinglePatientProgress: (patientId) =>
    api.post(API_PATHS.CLINICAL_PROGRESS_SINGLE, { patient_id: patientId }),

  // ─── Therapy Effectiveness Index ───────────────────────────────────────────

  // Therapy effectiveness rankings
  getTherapyEffectiveness: (data = {}) =>
    api.post(API_PATHS.CLINICAL_THERAPY_EFFECTIVENESS, data),

  // ─── Goal Achievement Tracker ──────────────────────────────────────────────

  // Goal achievement for all patients
  getGoalAchievement: (data = {}) =>
    api.post(API_PATHS.CLINICAL_GOALS, data),

  // Goal achievement for a single patient
  getSinglePatientGoals: (patientId) =>
    api.post(API_PATHS.CLINICAL_GOALS_SINGLE, { patient_id: patientId }),

  // ─── Stagnation Detection ─────────────────────────────────────────────────

  // Stagnation alerts for all patients
  getStagnationAlerts: (data = {}) =>
    api.post(API_PATHS.CLINICAL_STAGNATION, data),

  // ─── Clinical Recommendation Engine ────────────────────────────────────────

  // Clinical recommendations for all patients
  getAllRecommendations: (data = {}) =>
    api.post(API_PATHS.CLINICAL_RECOMMENDATIONS, data),

  // Clinical recommendations for a single patient
  getPatientRecommendations: (patientId) =>
    api.post(API_PATHS.CLINICAL_RECOMMENDATIONS_SINGLE, { patient_id: patientId }),
};

export default clinicalService;
